/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { softwareVersionDetailNoTabPathRedirectRoute } from '@jira/router-routes__software-versions-routes/src/softwareVersionDetailNoTabPathRedirectRoute.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { LazyVersionDetail } from './ui/version-detail/index.tsx';
import { VersionDetailPageLegacyRedirect } from './ui/VersionDetailPageLegacyRedirect.tsx';

export const softwareVersionDetailNoTabPathRedirectRouteEntry: Route = createEntry(
	softwareVersionDetailNoTabPathRedirectRoute,

	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: VersionDetailPageLegacyRedirect,
		canTransitionIn: () => true,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: [...getNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyVersionDetail],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
